<script lang="ts">
    import ProductPreview from "./ProductPreview.svelte"

    export let products: BKDFProduct[] = []
</script>

<div class="product-preview-list horizontalScrollbar">
    {#each products as product (product.id)}
        <ProductPreview product="{product}" />
    {/each}
</div>

<style lang="less">
    .product-preview-list {
        display: flex;
        overflow-x: auto;
        gap: 2.2rem;
        width: 100%;
        max-width: 100%;
    }
</style>
